import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleLogin from "@client.components/GoogleLogin";
import MicrosoftLogin from "@client.components/MicrosoftLogin";
import Icon from "@client.components/Icon";
import Loader from "@client.components/Loader";
import ErrorMessage from "@client.components/ErrorMessage";
import {
  makeLoginError,
  makeLoginLoading,
  makeLoginSyncLoading,
  setLoginError,
} from "./reducer";
import { useTranslation } from "react-i18next";
import "./Login.scss";

const Login = () => {
  const loginError = useSelector(makeLoginError);
  const loginLoading = useSelector(makeLoginLoading);
  const loginSyncLoading = useSelector(makeLoginSyncLoading);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const ERROR_GET_PARAM = "error";

    const urlParams = new URLSearchParams(window.location.search);
    const errorParam = urlParams.get(ERROR_GET_PARAM);

    if (errorParam) {
      dispatch(setLoginError(errorParam));

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete(ERROR_GET_PARAM);
      window.history.replaceState({}, "", newUrl);
    }
  }, [dispatch]);

  return (
    <div className="login">
      <ErrorMessage template="pages.Login.failedLogin" message={loginError} />
      <div className="login-container">
        <Icon name="logo-main" className="logo" isSvg={true} />
        <div className="btns">
          {loginLoading && <Loader loading={true} />}
          {loginSyncLoading && (
            <span className="sync-loading">
              {t("pages.Login.syncCalendarEvents")}
            </span>
          )}
          <GoogleLogin hide={loginLoading} />
          <MicrosoftLogin hide={loginLoading} />
        </div>
      </div>
    </div>
  );
};

export default Login;
